<template>
    <i class="icon" :class="{['icon-'+icon]: true, [$props['class']]: !!$props['class']}" />
</template>

<script>
export default {
    name: "v-icon",
    props: {
        icon: { type: String, required: true }
    }

}
</script>

<style scoped>

</style>